<template>
    <div>
        <a-divider :style="{marginTop: '0px'}"/>
        <div :style="{fontSize: '16px'}">
            <strong>
                <a-row>
                    <a-col :span="18" :offset="1">
                        <span v-if="showHotwords">
                            热搜排行 <a-icon type="fire" />
                        </span>
                        <span v-else>
                            <a @click.prevent.stop="showHotwords=true">热搜排行 <a-icon type="fire" /></a>
                        </span>
                        <a-divider type="vertical" />
                        <span v-if="! showHotwords">
                            最近搜索 <a-icon type="clock-circle" />
                        </span>
                        <span v-else>
                            <a @click.prevent.stop="showHotwords=false">最近搜索 <a-icon type="clock-circle" /></a>
                        </span>
                    </a-col>
                    <a-col v-if="! showHotwords && recentwords.length > 0" :span="3">
                        <span @click="clearSearchWords">清空</span>
                    </a-col>
                </a-row>
            </strong>
            <div v-if="showHotwords">
                <template v-for="item in hotwords">
                    <div :key="item"  @click="toSearch(item)">
                        <a-row :style="{lineHeight:'45px'}" class="pk-search-word">
                            <a-col :span="2" :offset="1">
                                <a-icon type="fire" />
                            </a-col>
                            <a-col :span="20" :offset="1">
                                <em>{{item}}</em>
                            </a-col>
                        </a-row>
                    </div>
                </template>
            </div>
            <div v-else>
                <template v-for="item in recentwords">
                    <div :key="item" @click="toSearch(item)">
                        <a-row :style="{lineHeight:'45px'}" class="pk-search-word">
                            <a-col :span="2" :offset="1">
                                <a-icon type="clock-circle" />
                            </a-col>
                            <a-col :span="15" :offset="1">
                                <em>{{item}}</em>
                            </a-col>
                            <a-col :span="2" class="pk-search-word-close-icon">
                                <a-icon type="close" @click.prevent.stop="deleteWord(item)"/>
                            </a-col>
                        </a-row>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import { BLOG_SEARCH_HOT_WORD } from "@/components/constant/url_path";
    import { SEARCH, DEL_SEARCH_WORD } from "@/components/constant/action_types";
    import { SEARCH_WORD_ARRAY} from "@/components/constant/getter_types";
    import { UPDATE_SEARCH_WORDS } from "@/components/constant/mutation_types";
    import { mapActions, mapGetters, mapMutations } from 'vuex';

    export default {
        name: "HotSearch",
        created() {
            this.fetchHotwords();
            if (this.recentwords.length > 3) {
                this.showHotwords = false;
            }
        },
        computed: {
            ...mapGetters({
                'recentwords':SEARCH_WORD_ARRAY
            })
        },
        data() {
            return {
                showHotwords: true,
                hotwords:[]
            }
        },
        methods: {
            ...mapMutations({
                'updateSearchWords': UPDATE_SEARCH_WORDS
            }),
            ...mapActions({
                'search': SEARCH,
                'delSearchWord': DEL_SEARCH_WORD
            }),
            fetchHotwords() {
                let _this = this;
                _this.$axios.get(BLOG_SEARCH_HOT_WORD)
                    .then(function (response) {
                        if (response.data.code == 200) {
                            _this.hotwords = response.data.result;
                        }
                    })
            },
            toSearch(keyword) {
                let key = [this.$route.path.split("/")[1].length > 0 ? this.$route.path.split("/")[1] : 'home'];
                let isSearch = "search" == key;
                if (keyword && keyword != '') {
                    this.search(keyword);
                }
                if (isSearch) {
                    window.location.href = this.$route.path.concat("?q=").concat(keyword)
                } else {
                    window.open('/search?q='.concat(keyword), "_blank");
                }
            },
            deleteWord(word) {
                this.delSearchWord(word);
            },
            clearSearchWords() {
                this.updateSearchWords('');
            }
        }
    }
</script>

<style scoped>
    .menu-item, .ant-list {
        font-size: 16px;
    }
    .ant-list-item:hover {
        background-color: gainsboro;
    }
    .pk-search-word:hover {
        background-color: gainsboro;
    }

</style>